module.exports = __webpack_public_path__ + "img/cap.a37316b1.png";